import * as files from '../assets/files.json';
const articleOne = {
  id: 1,
  logo: files.article1,
  title: 'Who Can Sign Up For PERA?',
  date: '07-Sep-2020 17:35:29',
  author: 'Bryce Zialcita',
  slug: `
    <p>If you’re a Filipino, aged 18 and above, with a Tax Identification Number (TIN), you are qualified to make a PERA investment. </p>
    <p>Imagine the possibilities when you have money saved up for your future goals.</p>
  `,
};

const articleTwo = {
  id: 2,
  logo: files.article2,
  title: 'What Are The Benefits of PERA?',
  date: '07-Sep-2020 17:35:10',
  author: 'Bryce Zialcita',
  slug: `
    <p>By the time you reach the age of 55 and have invested in a PERA fund for at least 5 years, you’ll be able to redeem your PERA investments tax-free.</p>
    <p>Aside from the aforementioned tax-free redemptions for PERA investments, you’ll be able to enjoy a 5% tax credit as long as the annual PERA Contribution does not exceed Php 100,000 for Filipinos based in the Philippines and Php 200,000 for OFWs.</p>
    <p>Another benefit of PERA is that in case of death of the contributor, his/her PERA contributions will be exempt from estate tax. </p>
    `,
};

const articleThree = {
  id: 3,
  logo: files.article3,
  title: 'What Is PERA?',
  date: '07-Sep-2020 17:27:15',
  author: 'Bryce Zialcita',
  slug: `
    <p>PERA is short for Personal Equity and Retirement Account created under Republic Act No. 9505. </p>
    <p>It is a voluntary pension fund that is regulated by the Bangko Sentral ng Pilipinas (BSP). It lets you invest in various types of managed funds, which would help you prepare for retirement. By the time you reach the age of 55 and have invested in a PERA fund for at least 5 years, you’ll be able to redeem your PERA investments tax-free.</p>

    `,
};

const articleFour = {
  id: 4,
  logo: files.article4,
  title: 'What is a Mutual Fund?',
  date: '19-Sep-2016 09:57:22',
  author: 'Officer',
  slug: `
    <p>A mutual fund is an investment company which manages a pool of money on behalf of individual and/or institutional investors. The appointed fund manager invests the pool in a mix of securities (typically stocks, bonds, or some combination of these) in accordance with the funds stated objectives and strategies. 
    A mutual fund is an ideal investment vehicle for people focused on their careers or businesses, and who don't have the time, expertise or interest to devise their own investing strategies. In effect, a saver delegates the investing decisions to the fund manager. </p>
    <p>Mutual funds in the Philippines are heavily patterned after those in the U. S., where they have operated since 1924. Today, about half of all U. S. households are invested in mutual funds. Around the world, mutual funds are powerful engines for investors to save and build capital. </p>

    `,
};

const articleFive = {
  id: 5,
  logo: files.article5,
  title: 'Understanding Mutual Funds',
  date: '05-Sep-2016 10:27:47',
  author: 'Sonny Permana',
  slug: `
    <p>Just what are Mutual Funds and how can they work to your advantage?</p>
    <blockquote class=blockquote>
      <p> You know how when you own shares of a company, you make money when the company makes money? A Mutual Fund is a lot like that.</p>
    </blockquote>

    <p>A Mutual Fund is actually an investment company that collects money from several investors by selling them its shares. </p>
    <blockquote class=blockquote>
      <p> So when you invest in a mutual fund, you essentially become a shareholder!</p>
    </blockquote>

    <p>What happens to the money you invest in a Mutual Fund?</p>
    <blockquote class=blockquote>
      <p>This is where the expertise of a professional fund manager comes in.</p>
    </blockquote>
    <blockquote class=blockquote>
      <p>The manager will take all the money invested into the fund by different people, and then use this money to invest in different securities like company stocks and bonds.</p>
    </blockquote>

    <p>When the team wins, you win.</p>
    <blockquote class=blockquote>
      <p>What’s great about Mutual Funds is that, by combining your money with that from different people, you get a whole lot more purchasing power together.</p>
    </blockquote>
    <blockquote class=blockquote>
      <p>It’s kind of like you and your friends pooling your money to buy lottery tickets. You can buy more tickets as a group, and thereby increase everyone’s chances of winning.</p>
    </blockquote>
    <blockquote class=blockquote>
      <p>And the fund manager? He’s there to lead your team and pick out the best numbers for you.</p>
    </blockquote>

    <p>So how do you earn money from Mutual Funds?</p>
    <blockquote class=blockquote>
      <p>It all depends on what securities your fund manager invested in, and how well they perform.
      Assuming that things go well, here are two ways your money might grow:</p>
      <p>It all depends on what securities your fund manager invested in, and how well they perform.
      Assuming that things go well, here are two ways your money might grow:</p>
    </blockquote>

    <p>What kind of risk are we talking about here?</p>
    <blockquote class=blockquote>
      <p>    Because mutual funds are spread out over a lot of different investments, they’re less risky than putting all your money into a single stock. If one investment fails, you still have others to fall back on. But since no one can really predict how the market will perform, there’s definitely risk involved.</p>
    </blockquote>
    <blockquote class=blockquote>
      <p>Luckily, there are four types of mutual funds to choose from, and some are less risky than others.</p>
    </blockquote>

    <p>4 Types of Mutual Funds</p>
    <blockquote class=blockquote>
      <p>Money Market – invests mostly in fixed-income (aka more stable) securities</p>
      <p>Bond – similar to Money Market, but the terms (how long your money is tied up) are longer</p>
      <p>Balance – invests in fixed-income securities and stocks (more unstable, but also capable of earning more)</p>
      <p>Equity/Stock – buys shares of Philippine corporations     </p>
    </blockquote>

    <p>Why use Seedbox to invest in Mutual Funds?</p>
    <blockquote class=blockquote>
      <p>Seedbox makes it easier than ever to invest in Mutual Funds by taking the process online.
      All you have to do is sign up, then we’ll guide you through the steps that will turn you into a regular investor in no time.</p>
      <p>In fact, now is the best time to start. So open your Seedbox account today.</p>
    </blockquote>

    `,
};

const articleSix = {
  id: 6,
  logo: files.article6,
  title:
    'You probably already have a Savings Account. Do you really need to invest in Mutual Funds, too? Here’s why:',
  date: '12-Apr-2016 16:52:36',
  author: 'Officer',
  slug: `
    <p>Your money could grow more</p>
    <blockquote class=blockquote>
      <p>Mutual funds have the potential to earn you more money compared to the low but stable interest rates of regular savings accounts.</p>
    </blockquote>
    `,
};

const ArticleTexts = {
  articles: [
    articleOne,
    articleTwo,
    articleThree,
    articleFour,
    articleFive,
    articleSix,
  ],
  articleOne,
  articleTwo,
  articleThree,
  articleFour,
  articleFive,
  articleSix,
};

export default ArticleTexts;
